"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TitleBlockZen = exports.convertSecondaryActionsToMenuItems = exports.isMenuGroupNotButton = exports.isMenuItemNotButton = exports.NON_REVERSED_VARIANTS = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var button_1 = require("@kaizen/button");
var component_library_1 = require("@kaizen/component-library");
var arrow_backward_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/arrow-backward.icon.svg"));
var arrow_forward_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/arrow-forward.icon.svg"));
var hamburger_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/hamburger.icon.svg"));
var draft_avatar_1 = require("@kaizen/draft-avatar");
var draft_select_1 = require("@kaizen/draft-select");
var draft_tag_1 = require("@kaizen/draft-tag");
var responsive_1 = require("@kaizen/responsive");
var typography_1 = require("@kaizen/typography");
var MainActions_1 = __importDefault(require("./MainActions"));
var MobileActions_1 = __importDefault(require("./MobileActions"));
var SecondaryActions_1 = __importDefault(require("./SecondaryActions"));
var TitleBlockZen_module_scss_1 = __importDefault(require("./TitleBlockZen.module.scss"));
exports.NON_REVERSED_VARIANTS = ["education", "admin"];
var isMenuItemNotButton = function (value) { return "action" in value; };
exports.isMenuItemNotButton = isMenuItemNotButton;
var isMenuGroupNotButton = function (value) { return "menuItems" in value; };
exports.isMenuGroupNotButton = isMenuGroupNotButton;
var renderTag = function (surveyStatus) {
    var tagVariant;
    if (tagVariant === "profile") {
        return;
    }
    if (surveyStatus.status === "draft") {
        tagVariant = "statusDraft";
    }
    /*
      scheduled is actually a draft survey status that has a launch job scheduled
      still, we want to differentiate on the UI and render a specific tag
      the styles must be identical to the draft style
  
      we have similar behaviour on programs index page's table
    */
    if (surveyStatus.status === "scheduled") {
        tagVariant = "statusClosed";
    }
    if (surveyStatus.status === "live") {
        tagVariant = "statusLive";
    }
    if (surveyStatus.status === "closed") {
        tagVariant = "statusClosed";
    }
    if (surveyStatus.status === "default") {
        tagVariant = "default";
    }
    return (react_1["default"].createElement("div", { "data-automation-id": "survey-status-tag", "data-testid": "survey-status-tag", className: TitleBlockZen_module_scss_1["default"].tag },
        react_1["default"].createElement(draft_tag_1.Tag, { variant: tagVariant, size: "small" }, surveyStatus.text)));
};
var isJSXElement = function (imageElementOrAvatarProps) {
    return "props" in imageElementOrAvatarProps;
};
var renderAvatar = function (imageElementOrAvatarProps, avatarAutomationId) {
    return isJSXElement(imageElementOrAvatarProps) ? (react_1["default"].createElement("div", { "data-automation-id": avatarAutomationId, "data-testid": avatarAutomationId, className: (0, classnames_1["default"])(TitleBlockZen_module_scss_1["default"].avatar, TitleBlockZen_module_scss_1["default"].withBorder) }, imageElementOrAvatarProps)) : (react_1["default"].createElement("div", { "data-automation-id": avatarAutomationId, "data-testid": avatarAutomationId, className: TitleBlockZen_module_scss_1["default"].avatar },
        react_1["default"].createElement(draft_avatar_1.Avatar, __assign({}, imageElementOrAvatarProps, { size: "medium" }))));
};
var renderSubtitle = function (subtitle, subtitleAutomationId) { return (react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].subtitle },
    react_1["default"].createElement("span", { "data-automation-id": subtitleAutomationId, "data-testid": subtitleAutomationId, className: TitleBlockZen_module_scss_1["default"].subtitleText }, subtitle))); };
var defaultRenderSectionTitle = function (sectionTitle, sectionTitleDescription, variant, sectionTitleAutomationId, sectionTitleDescriptionAutomationId) { return (react_1["default"].createElement(react_1["default"].Fragment, null,
    sectionTitle && (react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].sectionTitle },
        react_1["default"].createElement(typography_1.Heading, { variant: "heading-2", color: isReversed(variant) ? "white" : "dark", classNameOverride: TitleBlockZen_module_scss_1["default"].sectionTitleOverride, "data-automation-id": sectionTitleAutomationId, "data-testid": sectionTitleAutomationId }, sectionTitle))),
    sectionTitleDescription && (react_1["default"].createElement("div", { "data-automation-id": sectionTitleDescriptionAutomationId, "data-testid": sectionTitleDescriptionAutomationId, className: (0, classnames_1["default"])(TitleBlockZen_module_scss_1["default"].sectionTitleDescription, !isReversed(variant) && TitleBlockZen_module_scss_1["default"].dark) }, sectionTitleDescription)))); };
var Breadcrumb = function (_a) {
    var breadcrumb = _a.breadcrumb, automationId = _a.automationId, textAutomationId = _a.textAutomationId, textDirection = _a.textDirection;
    var path = breadcrumb.path, handleClick = breadcrumb.handleClick, text = breadcrumb.text, render = breadcrumb.render;
    var icon = textDirection === "rtl" ? arrow_forward_icon_svg_1["default"] : arrow_backward_icon_svg_1["default"];
    var InnerContents = function () { return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].circle },
            react_1["default"].createElement(component_library_1.Icon, { icon: icon, role: "presentation" })),
        react_1["default"].createElement("span", { className: TitleBlockZen_module_scss_1["default"].breadcrumbTextLink, "data-automation-id": textAutomationId, "data-testid": textAutomationId },
            react_1["default"].createElement("span", { className: TitleBlockZen_module_scss_1["default"].breadcrumbText }, text)))); };
    if (render) {
        var CustomRender = render;
        return (react_1["default"].createElement(CustomRender, { breadcrumb: breadcrumb, className: TitleBlockZen_module_scss_1["default"].breadcrumb, automationId: automationId, textAutomationId: textAutomationId, textDirection: textDirection },
            react_1["default"].createElement(InnerContents, null)));
    }
    var TagName = path ? "a" : "button";
    return (react_1["default"].createElement(TagName, __assign({}, (path && { href: path }), { className: TitleBlockZen_module_scss_1["default"].breadcrumb, "data-automation-id": automationId, "data-testid": automationId, onClick: handleClick }),
        react_1["default"].createElement(InnerContents, null)));
};
// We want to accept undefined here because the NavigationTabs container is
// important for the flex-based layout (it pushes Secondary Actions over to the right)
var renderNavigationTabs = function (navigationTabs, collapse, ariaLabel) { return (react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].navigationTabScrollerContainer },
    react_1["default"].createElement("div", { className: (0, classnames_1["default"])(TitleBlockZen_module_scss_1["default"].navigationTabsContainer, collapse && TitleBlockZen_module_scss_1["default"].navigationTabsContainerCollapsed) }, !collapse && navigationTabs !== undefined && (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement("span", { className: TitleBlockZen_module_scss_1["default"].navigationTabEdgeShadowLeft }),
        react_1["default"].createElement("nav", { className: TitleBlockZen_module_scss_1["default"].navigationTabsNav, "aria-label": ariaLabel },
            react_1["default"].createElement("ul", { className: TitleBlockZen_module_scss_1["default"].navigationTabsList }, navigationTabs.map(function (navigationTab, index) { return (react_1["default"].createElement("li", { key: index }, navigationTab)); }))),
        react_1["default"].createElement("span", { className: TitleBlockZen_module_scss_1["default"].navigationTabEdgeShadowRight })))))); };
var isReversed = function (variant) {
    // The default variant (no variant prop) is reversed (dark background)
    if (variant === undefined)
        return true;
    return !exports.NON_REVERSED_VARIANTS.includes(variant);
};
var convertSecondaryActionsToMenuItems = function (secondaryActions) {
    return secondaryActions.reduce(function (acc, cur) {
        if ("menuItems" in cur) {
            return __spreadArray(__spreadArray([], acc, true), cur.menuItems, true);
        }
        if ("component" in cur) {
            return __spreadArray(__spreadArray([], acc, true), [cur], false);
        }
        var out = {
            label: cur.label,
            icon: cur.icon,
            destructive: cur.destructive,
            disabled: cur.disabled
        };
        if ("onClick" in cur || ("onClick" in cur && "href" in cur)) {
            return __spreadArray(__spreadArray([], acc, true), [
                __assign(__assign({}, out), { action: cur.onClick }),
            ], false);
        }
        if ("href" in cur) {
            return __spreadArray(__spreadArray([], acc, true), [
                __assign(__assign({}, out), { action: cur.href }),
            ], false);
        }
        return acc;
    }, new Array());
};
exports.convertSecondaryActionsToMenuItems = convertSecondaryActionsToMenuItems;
var createTabletOverflowMenuItems = function (secondaryActions, secondaryOverflowMenuItems) {
    var secondaryActionsList;
    if (secondaryActions) {
        secondaryActionsList = secondaryActions
            ? (0, exports.convertSecondaryActionsToMenuItems)(secondaryActions)
            : [];
    }
    else {
        secondaryActionsList = [];
    }
    var flatSecondaryOverflowItemsList = secondaryOverflowMenuItems || [];
    return secondaryActionsList.concat(flatSecondaryOverflowItemsList);
};
/**
 * {@link https://cultureamp.design/components/title-block/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/story/components-title-block--default Storybook}
 *
 * ### primaryAction
 *
 * The primary action (the "main" button in the top right) can either be a Button,
 * or a Button that reveals a Menu (a menu button).
 *
 * If you want it to be a Button, you can't pass in a `<Button />`, because the Title Block needs to grab the Button's
 * props and use them to render the mobile actions drawer as well as the Button itself. Instead, you have to pass
 * in the Button's props as an object, and there must be a `primary` property set to `true`.
 *
 * ```typescript
 * type PrimaryActionProps =
 *  | MenuGroup
 *  | (TitleBlockButtonProps & { primary: true })
 * ```
 *
 * If you want it to be a Menu, pass in this object of type `MenuGroup`:
 * ```typescript
 * {
 *   label: string
 *   menuItems: MenuItemProps[]
 * }
 * ```
 * Using the `label`, the Title Block will render a Button with a chevron icon and your `menuItems` will appear
 * in the dropdown menu when you click it. (`MenuItemProps` is a type imported from the `Menu` component.)
 *
 * ### secondaryActions & secondaryOverflowMenuItems
 *
 * Secondary Actions sit below the Primary Actions, and consist of
 * - actions/links (just a button),
 * - menus (a menu button), and
 * - the overflow menu (a menu button with a "meatballs" icon).
 *
 * **IMPORTANT:** The visual order of these from left to right should always be:
 * ```text
 * buttons (far left) -> menu buttons -> overflow menu (far right)
 * ```
 *
 * The overflow menu has a separate prop that accepts an array of `MenuItemProps`:
 *
 * ```typescript
 * secondaryOverflowMenuItems?: MenuItemProps[]
 * ```
 *
 * The `secondaryActions` prop accepts an **array** of objects.
 * Each object can be a MenuGroup (see code snippet for `primaryAction` above) or an object containing Button props:
 *
 * ```typescript
 * type SecondaryActionsProps = Array<MenuGroup | TitleBlockButtonProps>
 * ```
 * The order of elements in the array will determine the visual order on the page, so
 * please be aware of the intended order mentioned above.
 */
var TitleBlockZen = function (_a) {
    var title = _a.title, variant = _a.variant, breadcrumb = _a.breadcrumb, avatar = _a.avatar, subtitle = _a.subtitle, sectionTitle = _a.sectionTitle, sectionTitleDescription = _a.sectionTitleDescription, renderSectionTitle = _a.renderSectionTitle, pageSwitcherSelect = _a.pageSwitcherSelect, handleHamburgerClick = _a.handleHamburgerClick, primaryAction = _a.primaryAction, defaultAction = _a.defaultAction, secondaryActions = _a.secondaryActions, secondaryOverflowMenuItems = _a.secondaryOverflowMenuItems, navigationTabs = _a.navigationTabs, _b = _a.collapseNavigationAreaWhenPossible, collapseNavigationAreaWhenPossible = _b === void 0 ? false : _b, textDirection = _a.textDirection, surveyStatus = _a.surveyStatus, _c = _a.titleAutomationId, titleAutomationId = _c === void 0 ? "TitleBlock__Title" : _c, _d = _a.avatarAutomationId, avatarAutomationId = _d === void 0 ? "TitleBlock__Avatar" : _d, _e = _a.subtitleAutomationId, subtitleAutomationId = _e === void 0 ? "TitleBlock__Subtitle" : _e, _f = _a.sectionTitleAutomationId, sectionTitleAutomationId = _f === void 0 ? "TitleBlock__SectionTitle" : _f, _g = _a.sectionTitleDescriptionAutomationId, sectionTitleDescriptionAutomationId = _g === void 0 ? "TitleBlock__SectionTitleDescription" : _g, _h = _a.breadcrumbAutomationId, breadcrumbAutomationId = _h === void 0 ? "TitleBlock__Breadcrumb" : _h, _j = _a.breadcrumbTextAutomationId, breadcrumbTextAutomationId = _j === void 0 ? "TitleBlock__BreadcrumbText" : _j;
    var hasNavigationTabs = navigationTabs && navigationTabs.length > 0;
    var collapseNavigationArea = collapseNavigationAreaWhenPossible &&
        !hasNavigationTabs &&
        secondaryActions === undefined;
    var _k = (0, responsive_1.useMediaQueries)().queries, isSmall = _k.isSmall, isMedium = _k.isMedium;
    var isSmallOrMediumViewport = isMedium || isSmall;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement("div", { className: (0, classnames_1["default"])(TitleBlockZen_module_scss_1["default"].titleBlock, TitleBlockZen_module_scss_1["default"]["".concat(variant, "Variant")], Boolean(subtitle) && TitleBlockZen_module_scss_1["default"].hasSubtitle, Boolean(pageSwitcherSelect) && TitleBlockZen_module_scss_1["default"].hasPageSwitcherSelect, collapseNavigationArea &&
                !(sectionTitle || sectionTitleDescription || renderSectionTitle) &&
                TitleBlockZen_module_scss_1["default"].collapseNavigationArea, title && title.length >= 30 && TitleBlockZen_module_scss_1["default"].hasLongTitle, subtitle &&
                typeof subtitle === "string" &&
                subtitle.length >= 18 &&
                TitleBlockZen_module_scss_1["default"].hasLongSubtitle, hasNavigationTabs && TitleBlockZen_module_scss_1["default"].hasNavigationTabs) },
            react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].titleRow },
                react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].titleRowInner },
                    react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].titleRowInnerContent },
                        react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].titleAndAdjacent },
                            breadcrumb && (react_1["default"].createElement(Breadcrumb, { breadcrumb: breadcrumb, automationId: breadcrumbAutomationId, textAutomationId: breadcrumbTextAutomationId, textDirection: textDirection })),
                            react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].titleAndAdjacentNotBreadcrumb },
                                react_1["default"].createElement(react_1["default"].Fragment, null,
                                    handleHamburgerClick && (react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].hamburger },
                                        react_1["default"].createElement(button_1.IconButton, { onClick: handleHamburgerClick, icon: hamburger_icon_svg_1["default"], label: "Open menu", reversed: isReversed(variant) }))),
                                    avatar && renderAvatar(avatar, avatarAutomationId),
                                    react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].titleAndSubtitle },
                                        react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].titleAndSubtitleInner },
                                            react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].title },
                                                react_1["default"].createElement(typography_1.Heading, { variant: "heading-1", color: isReversed(variant) ? "white" : "dark", classNameOverride: TitleBlockZen_module_scss_1["default"].titleTextOverride, "data-automation-id": titleAutomationId, "data-testid": titleAutomationId }, title)),
                                            isSmallOrMediumViewport && pageSwitcherSelect && (react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].pageSwitcherSelectUnderneathTitle },
                                                react_1["default"].createElement(draft_select_1.Select, __assign({}, pageSwitcherSelect, { variant: "secondary-small", reversed: true })))),
                                            subtitle &&
                                                renderSubtitle(subtitle, subtitleAutomationId))),
                                    surveyStatus && renderTag(surveyStatus),
                                    !isSmallOrMediumViewport && pageSwitcherSelect && (react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].pageSwitcherSelectNextToTitle },
                                        react_1["default"].createElement(draft_select_1.Select, __assign({}, pageSwitcherSelect, { variant: "secondary", reversed: true, fullWidth: true }))))))),
                        (primaryAction ||
                            defaultAction ||
                            secondaryActions ||
                            secondaryOverflowMenuItems) && (react_1["default"].createElement(MainActions_1["default"], { primaryAction: primaryAction, defaultAction: defaultAction, reversed: isReversed(variant), overflowMenuItems: createTabletOverflowMenuItems(secondaryActions, secondaryOverflowMenuItems), showOverflowMenu: isSmallOrMediumViewport }))))),
            react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].rowBelowSeparator },
                react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].rowBelowSeparatorInner },
                    react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].rowBelowSeparatorInnerContent },
                        (sectionTitle ||
                            sectionTitleDescription ||
                            renderSectionTitle) && (react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].sectionTitleContainer },
                            react_1["default"].createElement("div", { className: TitleBlockZen_module_scss_1["default"].sectionTitleInner }, !!renderSectionTitle
                                ? renderSectionTitle({
                                    sectionTitle: sectionTitle,
                                    sectionTitleAutomationId: sectionTitleAutomationId,
                                    sectionTitleDescription: sectionTitleDescription,
                                    sectionTitleDescriptionAutomationId: sectionTitleDescriptionAutomationId
                                })
                                : defaultRenderSectionTitle(sectionTitle, sectionTitleDescription, variant, sectionTitleAutomationId, sectionTitleDescriptionAutomationId)))),
                        renderNavigationTabs(navigationTabs, collapseNavigationArea, title),
                        (secondaryActions || secondaryOverflowMenuItems) && (react_1["default"].createElement(SecondaryActions_1["default"], { secondaryActions: secondaryActions, secondaryOverflowMenuItems: secondaryOverflowMenuItems, reversed: isReversed(variant) }))))),
            react_1["default"].createElement(MobileActions_1["default"], { primaryAction: primaryAction, defaultAction: defaultAction, secondaryActions: secondaryActions, secondaryOverflowMenuItems: secondaryOverflowMenuItems, drawerHandleLabelIconPosition: primaryAction && "iconPosition" in primaryAction
                    ? primaryAction.iconPosition
                    : undefined }))));
};
exports.TitleBlockZen = TitleBlockZen;
exports.TitleBlockZen.displayName = "TitleBlockZen";
//# sourceMappingURL=TitleBlockZen.js.map